import React from "react";
import styles from "./styles.module.scss";
import useWindowWidth from "hooks/useWindowWidth";

const MissionBanner = () => {
  const width = useWindowWidth();
  return (
    <div className="container">
      <div className={styles.missionBanner}>
        <div className={styles.missionText}>Our mission</div>
        <div className={styles.description}>
          Empower mobile-first companies in their journey toward business growth
        </div>
        {width < 1024 && (
          <div className={styles.image}>
            <img
              src="/svgs/who-we-are/mission_bg_mobile.svg"
              alt="mission-banner-background"
              width="288"
              height="212"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MissionBanner;
